export const CHECKOUT_URL = 'https://sewing-pattern-making-instructor-atlas.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/b9dcc67f-9894-4323-9fab-752184f8f465/product-uploads/mcp_3be2d5dc-4422-4ea4-883f-58170f20e480_1793815147289.png'

export const HERO_IMAGE_ALT =
  'Sewing & Pattern Making Instructor Atlas 6-in-1 box set in plum, cream and gold: 6 visual sewing, pattern making and garment construction volumes for sewing instructors, pattern-making teachers and sewing academies'

export const VISUAL_IMAGE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/b9dcc67f-9894-4323-9fab-752184f8f465/product-uploads/mcp_3be2d5dc-4422-4ea4-883f-58170f20e480_1793815166909.jpg'

export const VISUAL_IMAGE_ALT =
  'Sewing & Pattern Making Instructor Atlas: the 6-volume box set next to a tablet with the sewing teaching areas, 100% visual material for sewing instructors, from beginner to advanced, with immediate access'

export const PRIMARY_CTA = 'GET SEWING & PATTERN MAKING INSTRUCTOR ATLAS NOW!'

export const PRICE_LABEL = '$27 USD'

export interface IncludedItem {
  label: string
  kind: 'included' | 'bonus' | 'extra'
}

export const packageIncludes: IncludedItem[] = [
  { kind: 'included', label: 'Volume 01 — Sewing Fundamentals, Tools, Fabrics & Machine Techniques' },
  { kind: 'included', label: 'Volume 02 — Pattern Making, Body Measurements & Garment Drafting' },
  { kind: 'included', label: 'Volume 03 — Advanced Pattern Making, Draping & Garment Fitting' },
  { kind: 'included', label: 'Volume 04 — Garment Cutting, Assembly & Construction Techniques' },
  { kind: 'included', label: 'Volume 05 — Professional Tailoring, Finishing Techniques & Garment Alterations' },
  { kind: 'included', label: 'Volume 06 — Sewing Instruction, Teaching Programs & Practical Assessments' },
  { kind: 'bonus', label: 'Sewing Techniques & Stitch Reference Flashcards' },
  { kind: 'bonus', label: 'Sewing Demonstration Lesson Scripts' },
  { kind: 'bonus', label: 'Pattern Making Practice Drills & Quarter-Scale Exercises' },
  { kind: 'bonus', label: 'Fitting & Alterations Troubleshooting Cards' },
  { kind: 'bonus', label: 'Sewing Competency Checklists, Rubrics & Certificates' },
  { kind: 'extra', label: '100% Visual Training System' },
  { kind: 'extra', label: 'Immediate Digital Access' },
  { kind: 'extra', label: 'One-Time Payment' },
]
